import { Component } from '@angular/core';
import { SkipConversation__SkipEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Conversations__Skip') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-skipconversation__skip-form',
    templateUrl: './skipconversation__skip.form.component.html'
})
export class SkipConversation__SkipFormComponent extends BaseFormComponent {
    public record!: SkipConversation__SkipEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'conversationDetailsSkip', sectionName: 'Conversation Details__Skip', isExpanded: false },
            { sectionKey: 'learningCycleNotes', sectionName: 'Learning Cycle Notes', isExpanded: false }
        ]);
    }
}

